import AuthLayout from "@/components/layouts/AuthLayout";
import ForgotPassword from "@/panel/auth/ForgotPassword";
import { useNavigate } from "react-router";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const onVerified = () => {
    navigate("/dashboard");
  };
  
  return (
    <AuthLayout>
      <ForgotPassword />
    </AuthLayout>
  );
}
